import {
    IClassificacaoCliente,
    IContrato,
} from "../../../Interfaces/Cobranca/Contrato/ContratoInterfaces";
import {
    AlterarClassificacaoClienteService,
    ExcluirContratosCampanhaService,
    ExcluirContratosEmMassaService,
    ExcluirContratosPorGrupoService,
    ExcluirContratosService,
    ExportarContratosDistribuidosService,
    ExportarContratosNaoDistribuidosService,
    InserirContratosCampanhaService,
    ListarContratosDistribuidosPorGruposService,
    ListarContratosDistribuidosService,
    ListarContratosNaoDistribuidosService,
} from "../../../Services/Cobranca/Contrato/DistribuicaoCarteiraServices";
import { Controller } from "../../Controller";

export const ListarContratosDistribuidosController = () =>
    Controller(ListarContratosDistribuidosService());

export const ListarContratosNaoDistribuidosController = () =>
    Controller(ListarContratosNaoDistribuidosService());

export const InserirContratosCampanhaController = (
    ID_GRUPO: number,
    lstCasoCobrancaFato: Array<IContrato>
) => Controller(InserirContratosCampanhaService(ID_GRUPO, lstCasoCobrancaFato));

export const ExcluirContratosController = (
    ID_CASO_COBRANCA_FILA_ATENDIMENTO: number
) => Controller(ExcluirContratosService(ID_CASO_COBRANCA_FILA_ATENDIMENTO));

export const ExcluirContratosPorGrupoController = (ID_GRUPO: number) =>
    Controller(ExcluirContratosPorGrupoService(ID_GRUPO));

export const ExportarContratosDistribuidosController = () =>
    Controller(ExportarContratosDistribuidosService());

export const ExportarContratosNaoDistribuidosController = () =>
    Controller(ExportarContratosNaoDistribuidosService());

export const ListarContratosDistribuidosPorGruposController = () =>
    Controller(ListarContratosDistribuidosPorGruposService());

export function ExcluirContratosCampanhaController(
    requestBody: Array<IContrato>
) {
    return Controller(ExcluirContratosCampanhaService(requestBody));
}

export function AlterarClassificacaoClienteController(
    requestBody: IClassificacaoCliente
) {
    return Controller(AlterarClassificacaoClienteService(requestBody));
}

export function ExcluirContratosEmMassaController(requestBody: number[]) {
    return Controller(ExcluirContratosEmMassaService(requestBody));
}
